module.exports = __webpack_public_path__ + "static/media/step13.5b4cf120.png";